export interface Region {
  id: string | number;
  name: string;
  code: string;
  description?: string;
}

export enum REGIONS_LABELS {
  NAM = "NAM",
  APAC = "APAC",
  EMEA = "EMEA",
  LATAM = "LATAM",
}

export enum REGIONS_IDS {
  NAM = 14,
  APAC = 15,
  EMEA = 16,
  LATAM = 17,
}

export type RegionKey =
  | (typeof REGIONS_LABELS)[keyof typeof REGIONS_LABELS]
  | "ALL"
  | "OTHER";

export const regionColors: Record<
  RegionKey,
  { color: string; background: string }
> = {
  NAM: { color: "white", background: "rgb(159, 137, 188)" },
  APAC: { color: "white", background: "rgb(78, 123, 162)" },
  EMEA: { color: "black", background: "rgb(219, 217, 161)" },
  LATAM: { color: "white", background: "rgb(210, 120, 90)" },
  ALL: { color: "white", background: "rgb(106, 122, 135)" },
  OTHER: { color: "white", background: "#6c757d" },
};
